import React, { memo } from "react";

const InfoIcon: React.FC = memo(() => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 16.5664C12.4183 16.5664 16 12.9847 16 8.56641C16 4.14813 12.4183 0.566406 8 0.566406C3.58172 0.566406 0 4.14813 0 8.56641C0 12.9847 3.58172 16.5664 8 16.5664ZM9.11133 13.2998V6.43164H7.5752V13.2998H9.11133ZM7.70215 4.05127C7.5498 4.20361 7.47363 4.39616 7.47363 4.62891C7.47363 4.85742 7.5498 5.04785 7.70215 5.2002C7.85872 5.35254 8.07454 5.42871 8.34961 5.42871C8.62044 5.42871 8.83415 5.35254 8.99072 5.2002C9.1473 5.04785 9.22559 4.85742 9.22559 4.62891C9.22559 4.39616 9.1473 4.20361 8.99072 4.05127C8.83415 3.89469 8.62044 3.81641 8.34961 3.81641C8.07454 3.81641 7.85872 3.89469 7.70215 4.05127Z"
        fill="currentColor"
      />
    </svg>
  );
});

export { InfoIcon };
